import React from "react";

const CallToAction = () => {
    return (
        <section id="call-to-action" className="call-to-action section bg-gradient-primary">
            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="cta-wrapper bg-white rounded-5 overflow-hidden shadow-xl">
                    <div className="content-block p-4 p-lg-6">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="text-content" data-aos="fade-right" data-aos-delay="200">
                                    <div className="section-label mb-3" data-aos="fade-up" data-aos-delay="250">
                                        <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2 d-inline-flex align-items-center">
                                            <i className="bi bi-rocket-takeoff me-2"></i>
                                            Start Your Academic Success Journey
                                        </span>
                                    </div>

                                    <h2 className="display-4 fw-bold mb-3" data-aos="fade-up" data-aos-delay="300">
                                        Ace Your Exams With
                                        <span className="text-gradient-primary"> Confidence</span>
                                    </h2>

                                    <p className="lead text-muted mb-4" data-aos="fade-up" data-aos-delay="350">
                                        Join thousands of successful students who have transformed their exam preparation 
                                        with our comprehensive platform. Get instant access to verified past questions, 
                                        expert guidance, and smart study tools.
                                    </p>

                                    <div className="benefits-list mb-4" data-aos="fade-up" data-aos-delay="400">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="benefit-item d-flex align-items-start p-3 rounded-3 bg-light border-0">
                                                    <div className="check-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                         style={{
                                                             width: '32px',
                                                             height: '32px',
                                                             background: 'var(--bs-success-bg-subtle)',
                                                             color: 'var(--bs-success)'
                                                         }}>
                                                        <i className="bi bi-check-lg"></i>
                                                    </div>
                                                    <div>
                                                        <span className="fw-semibold d-block">100% Verified Content</span>
                                                        <small className="text-muted">All answers checked by experts</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="benefit-item d-flex align-items-start p-3 rounded-3 bg-light border-0">
                                                    <div className="check-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                         style={{
                                                             width: '32px',
                                                             height: '32px',
                                                             background: 'var(--bs-primary-bg-subtle)',
                                                             color: 'var(--bs-primary)'
                                                         }}>
                                                        <i className="bi bi-check-lg"></i>
                                                    </div>
                                                    <div>
                                                        <span className="fw-semibold d-block">Unlimited Access</span>
                                                        <small className="text-muted">Study anytime, anywhere</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="benefit-item d-flex align-items-start p-3 rounded-3 bg-light border-0">
                                                    <div className="check-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                         style={{
                                                             width: '32px',
                                                             height: '32px',
                                                             background: 'var(--bs-warning-bg-subtle)',
                                                             color: 'var(--bs-warning)'
                                                         }}>
                                                        <i className="bi bi-check-lg"></i>
                                                    </div>
                                                    <div>
                                                        <span className="fw-semibold d-block">All Education Levels</span>
                                                        <small className="text-muted">BECE to University covered</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="benefit-item d-flex align-items-start p-3 rounded-3 bg-light border-0">
                                                    <div className="check-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                         style={{
                                                             width: '32px',
                                                             height: '32px',
                                                             background: 'var(--bs-info-bg-subtle)',
                                                             color: 'var(--bs-info)'
                                                         }}>
                                                        <i className="bi bi-check-lg"></i>
                                                    </div>
                                                    <div>
                                                        <span className="fw-semibold d-block">Mobile Friendly</span>
                                                        <small className="text-muted">Study on any device</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="action-group mb-4" data-aos="fade-up" data-aos-delay="450">
                                        <div className="d-flex flex-wrap gap-3">
                                            <a href="/questions" className="btn btn-primary btn-lg px-5 py-3 shadow-sm">
                                                <i className="bi bi-person-plus me-2"></i>
                                                Click to Download
                                            </a>
                                            <a href="/demo" className="btn btn-outline-primary btn-lg px-5 py-3">
                                                <i className="bi bi-play-circle me-2"></i>
                                                Watch Demo
                                            </a>
                                        </div>
                                    </div>

                                    <div className="trust-indicators" data-aos="fade-up" data-aos-delay="500">
                                        <div className="d-flex flex-wrap align-items-center gap-4">
                                            <div className="indicator text-center">
                                                <div className="metric display-6 fw-bold text-primary mb-1">300+</div>
                                                <div className="label text-muted">Active Students</div>
                                            </div>
                                            <div className="separator d-none d-md-block" style={{
                                                width: '1px',
                                                height: '40px',
                                                background: 'var(--bs-border-color)'
                                            }}></div>
                                            <div className="indicator text-center">
                                                <div className="metric display-6 fw-bold text-success mb-1">99%</div>
                                                <div className="label text-muted">Pass Rate</div>
                                            </div>
                                            <div className="separator d-none d-md-block" style={{
                                                width: '1px',
                                                height: '40px',
                                                background: 'var(--bs-border-color)'
                                            }}></div>
                                            <div className="indicator text-center">
                                                <div className="metric display-6 fw-bold text-warning mb-1">24/7</div>
                                                <div className="label text-muted">Study Support</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <div className="visual-section position-relative p-4" data-aos="fade-left" data-aos-delay="300">
                                    <div className="image-container position-relative">
                                        <div className="main-visual-wrapper rounded-4 overflow-hidden shadow-lg mb-4">
                                            <img 
                                                src="/assets/img/1.jpg" 
                                                alt="Students achieving academic success" 
                                                className="img-fluid w-100"
                                                style={{ height: '300px', objectFit: 'cover' }}
                                                onError={(e) => {
                                                    e.target.src = "/assets/img/cta/default-success.jpg";
                                                }}
                                            />
                                        </div>

                                        {/* Floating Badges */}
                                        <div className="floating-badges">
                                            <div className="floating-badge badge-1 bg-white rounded-4 shadow-sm p-3 d-flex align-items-center position-absolute"
                                                 style={{
                                                     top: '20px',
                                                     right: '20px',
                                                     maxWidth: '200px',
                                                     border: '1px solid var(--bs-border-color)',
                                                     zIndex: 2
                                                 }}
                                                >
                                                <div className="badge-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                     style={{
                                                         width: '40px',
                                                         height: '40px',
                                                         background: 'var(--bs-warning-bg-subtle)',
                                                         color: 'var(--bs-warning)'
                                                     }}>
                                                    <i className="bi bi-award-fill"></i>
                                                </div>
                                                <div className="badge-text">
                                                    <div className="badge-title fw-bold">Top Rated</div>
                                                    <div className="badge-subtitle text-muted">Educational Platform 2024</div>
                                                </div>
                                            </div>

                                            <div className="floating-badge badge-2 bg-white rounded-4 shadow-sm p-3 d-flex align-items-center position-absolute"
                                                 style={{
                                                     bottom: '40px',
                                                     left: '20px',
                                                     maxWidth: '180px',
                                                     border: '1px solid var(--bs-border-color)',
                                                     zIndex: 2
                                                 }}
                                                >
                                                <div className="badge-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                                                     style={{
                                                         width: '40px',
                                                         height: '40px',
                                                         background: 'var(--bs-primary-bg-subtle)',
                                                         color: 'var(--bs-primary)'
                                                     }}>
                                                    <i className="bi bi-mortarboard-fill"></i>
                                                </div>
                                                <div className="badge-text">
                                                    <div className="badge-title fw-bold">20+</div>
                                                    <div className="badge-subtitle text-muted">Distinctions</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Education Levels Chart */}
                                        <div className="education-chart bg-light rounded-4 p-3 mt-4 shadow-sm">
                                            <h6 className="fw-bold mb-3 text-center">Student Success by Level</h6>
                                            <div className="row g-2">
                                                {[
                                                    { level: "BECE", percentage: "95%", color: "primary" },
                                                    { level: "SHS/WASSCE", percentage: "92%", color: "success" },
                                                    { level: "CTVET", percentage: "88%", color: "warning" },
                                                    { level: "University", percentage: "90%", color: "info" }
                                                ].map((item, index) => (
                                                    <div key={index} className="col-6">
                                                        <div className="level-progress">
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <span className="text-muted">{item.level}</span>
                                                                <span className={`fw-bold text-${item.color}`}>{item.percentage}</span>
                                                            </div>
                                                            <div className="progress" style={{ height: '8px' }}>
                                                                <div 
                                                                    className={`progress-bar bg-${item.color}`}
                                                                    role="progressbar" 
                                                                    style={{ width: item.percentage }}
                                                                    aria-valuenow={parseInt(item.percentage)}
                                                                    aria-valuemin="0" 
                                                                    aria-valuemax="100"
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Testimonial Quote */}
                                    <div className="testimonial-quote bg-primary bg-opacity-10 rounded-4 p-4 mt-4 border-start border-4 border-primary">
                                        <div className="d-flex align-items-start">
                                            <i className="bi bi-quote fs-1 text-primary opacity-25 me-3"></i>
                                            <div>
                                                <p className="mb-2">
                                                    "This platform helped me pass my WASSCE exams with distinctions. 
                                                    The past questions were exactly what I needed!"
                                                </p>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm rounded-circle bg-primary me-2"
                                                         style={{ width: '30px', height: '30px' }}></div>
                                                    <div>
                                                        <small className="fw-semibold d-block">Kwame Mensah</small>
                                                        <small className="text-muted">SHS Graduate, 2023</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Offer */}
                <div className="additional-offer text-center mt-5">
                    <div className="bg-light rounded-4 p-4 border border-primary border-opacity-25">
                        <div className="row align-items-center">
                            <div className="col-md-8 text-md-start">
                                <h5 className="fw-bold mb-2">
                                    <i className="bi bi-gift-fill text-warning me-2"></i>
                                    Limited Time Offer: Get 30 Days Free Premium Access
                                </h5>
                                <p className="text-muted mb-0">
                                    Start your free trial today and get full access to all premium features
                                </p>
                            </div>
                            <div className="col-md-4 text-md-end mt-3 mt-md-0">
                                <a href="/questions" className="btn btn-warning btn-lg">
                                    <i className="bi bi-lightning-fill me-2"></i>
                                    Claim Offer
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .call-to-action {
                    padding: 6rem 0;
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                }
                
                .bg-gradient-primary {
                    background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(111, 66, 193, 0.05) 100%);
                }
                
                .shadow-xl {
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1) !important;
                }
                
                .p-lg-6 {
                    padding: 4rem !important;
                }
                
                .text-gradient-primary {
                    background: linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-purple) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                
                .floating-badge {
                    transition: all 0.3s ease;
                }
                
                .floating-badge:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
                }
                
                .education-chart {
                    transition: all 0.3s ease;
                }
                
                .education-chart:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
                }
                
                .testimonial-quote {
                    transition: all 0.3s ease;
                }
                
                .testimonial-quote:hover {
                    box-shadow: 0 10px 25px rgba(var(--bs-primary-rgb), 0.1);
                }
                
                .progress-bar {
                    border-radius: 4px;
                }
                
                .avatar-sm {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-weight: bold;
                    background: var(--bs-primary);
                }
                
                @media (max-width: 992px) {
                    .call-to-action {
                        padding: 4rem 0;
                    }
                    
                    .p-lg-6 {
                        padding: 2rem !important;
                    }
                    
                    .display-4 {
                        font-size: 2.5rem;
                    }
                }
                
                @media (max-width: 768px) {
                    .call-to-action {
                        padding: 3rem 0;
                    }
                    
                    .cta-wrapper {
                        margin: 0 1rem;
                    }
                    
                    .floating-badges {
                        position: static !important;
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                        margin-bottom: 1rem;
                    }
                    
                    .floating-badge {
                        position: static !important;
                        max-width: 100% !important;
                    }
                    
                    .benefits-list .col-md-6 {
                        margin-bottom: 1rem;
                    }
                    
                    .trust-indicators .separator {
                        display: none !important;
                    }
                    
                    .trust-indicators .indicator {
                        flex: 1;
                        min-width: 120px;
                    }
                }
                
                @media (max-width: 576px) {
                    .display-4 {
                        font-size: 2rem;
                    }
                    
                    .btn-lg {
                        padding: 0.75rem 1.5rem !important;
                        font-size: 1rem;
                    }
                    
                    .action-group {
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .action-group .btn {
                        width: 100%;
                    }
                }
            `}</style>
        </section>
    );
};

export default CallToAction;